import {faMemoCircleInfo} from "@fortawesome/pro-solid-svg-icons/faMemoCircleInfo";
import {faPuzzlePiece} from "@fortawesome/pro-solid-svg-icons/faPuzzlePiece";
import {faReceipt} from "@fortawesome/pro-solid-svg-icons/faReceipt";
import {faSliders} from "@fortawesome/pro-solid-svg-icons/faSliders";
import {ColourSolid} from "@twigsby/frontend-framework";
import AppIntegrations from "../../Pages/User/Plan/AppIntegrations";
import Preferences from "../../Pages/User/Plan/Preferences";
import PlanDetails from "../../Pages/User/Plan/PlanDetails";
import Statements from "../../Pages/User/Plan/Statements";
import {SuggestibleRouteInterface} from "../TopRoutes";

const YourPlanRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Preferences',
        path: '/manage-account/plan/preferences',
        icon: faSliders,
        element: <Preferences />,
        colour: ColourSolid.Success,
        group: 'Your Plan'
    },
    {
        title: 'Plan Details',
        path: '/manage-account/plan/details',
        icon: faMemoCircleInfo,
        element: <PlanDetails />,
        colour: ColourSolid.Success,
        group: 'Your Plan'
    },
    {
        title: 'Statements',
        icon: faReceipt,
        path: '/manage-account/plan/statements',
        element: <Statements />,
        colour: ColourSolid.Success,
        group: 'Your Plan'
    },
    {
        title: 'App Integrations',
        path: '/manage-account/app-integrations',
        icon: faPuzzlePiece,
        element: <AppIntegrations />,
        colour: ColourSolid.Success,
        group: 'Your Plan'
    },
]

export { YourPlanRoutes }
